export default "__VITE_ASSET__DO4K3nlz__"